import { useState, useEffect } from "react";
import { useAppSelector } from "../../../store/store";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import ModalSearch from "../../ModalSearch";
import { useUpdateProfileMutation } from "../../../store/appSlice";

function CandidateIndustry(props) {
  const { getUpdatedData } = props;
  const { user, profileData, allIndustries } = useAppSelector(
    (state) => state["user"]
  );
  const [allIndustriesNew, setAllIndustriesNew] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState(null); // Set initial value to null
  const [industriesModal, setIndustriesModal] = useState(false);
  const [updateProfile] = useUpdateProfileMutation();

  useEffect(() => {
    const tempAllIndustries = allIndustries.map((item) => {
      return {
        id: item.id,
        name: item.industryName,
      };
    });

    setAllIndustriesNew(tempAllIndustries);

    const findItemById = (id) => {
      return allIndustries.find((item) => item.id === id);
    };

    if (profileData?.candidate?.industryIds?.length) {
      const industry = findItemById(profileData.candidate.industryIds[0]);
      setSelectedIndustry(industry || null); // Set to null if industry is not found
    } else {
      setSelectedIndustry(null); // Ensure selectedIndustry is null if no industryIds
    }
  }, [profileData, allIndustries]);

  const onEditIndustry = () => {
    setIndustriesModal(true);
  };

  const onSave = (selectedData) => {
    let payload = {
      param: user?.id,
      industryIds: selectedData,
      skillIds: [],
      professionIds: [],
    };

    updateProfile(payload)
      .unwrap()
      .then(() => {
        getUpdatedData();
      });
  };

  return (
    <div className="container_sections_wrapper">
      <div
        className="candidate-about__r6-skills-only"
        style={{ display: "flex", flexDirection: "row" }}
      >
        <div>
          <h3 style={{ fontWeight: 700, fontSize: "17px" }}>Industry</h3>

          <div className="co-skills-only__skills-cont">
            <div className="coso-skills-cont__ind-skill-div">
              <h4>{selectedIndustry ? selectedIndustry.industryName : "No Industry Selected"}</h4>
            </div>
          </div>
        </div>
      </div>

      <div onClick={onEditIndustry} className="edit_icon">
        <ModeEditOutlineOutlinedIcon
          style={{ height: "20px", width: "20px" }}
        />{" "}
      </div>
      {industriesModal && (
        <ModalSearch
          dataList={allIndustriesNew}
          onDataSave={onSave}
          selectedData={selectedIndustry ? [selectedIndustry] : []} // Pass empty array if no selectedIndustry
          isVisible={industriesModal}
          selectionLimit={1}
          onClose={() => setIndustriesModal(false)} // Correctly close the modal
        />
      )}
    </div>
  );
}

export default CandidateIndustry;
